import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginApp2FA } from '../../redux/actions/app';
import { withTranslation  } from 'react-i18next';
import Language from './Language.jsx';

export class Login2FA extends Component {
  constructor(props){
    super(props);

    this.state = {
      mode: 0,
      email: props.email
    };
  }

  login2FA = (e) => {
    e.preventDefault();
    const form = document.getElementById('2FAlogin').elements;
    const password = form[0].value;
    const email = this.state.email;

    this.props.dispatch(loginApp2FA(password, email));
  }

  changeMode = (i) => {
    let tempState = {...this.state};
    tempState.mode = i;
    this.setState(tempState);
  }

  render() {
    const { t } = this.props;
    let button = t('common.LoginBtn');
    let submit = this.login2FA;
    if (this.state.mode === 1) {
      button = t('common.SignUpBtn');
      submit = this.signup;
    }

    return (
      <div className="login">

        {/* <Toggle
          mode={this.state.mode}
          changeMode={this.changeMode}
        /> */}
        <Language />
        <form id="2FAlogin" onSubmit={submit}>
          <h2>{ t('login2FA.pleaseCheckEmail') }</h2>
          <div className='email-box'>
            <div className='email-title'>{ t('login2FA.VerificationCode') }:</div>
            <input className="input" required type="password" placeholder=""></input>
          </div>
          <input className="input" required type="hidden"></input>
          <button type="submit" className="button-secondary uppercase">{ t('common.SubmitBtn') }</button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    email: state.login.email
  }
}
export default connect(
  mapStateToProps
)(withTranslation()(Login2FA));



// WEBPACK FOOTER //
// ./src/js/containers/Login2FA.jsx